import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmsCampaignListViews {
    id?: number;
    sms_campaign_id?: number;
    name?: string;
    message?: string;
    status?: number;
    schedule_time: string;
    retries: number;
    xls_file: string,
    xls_file_name: string;
    numbers_count: number;
    number_to_be_processed: number;
    failed_reason: string;
    createdAt: string;
    updatedAt: string;
    campaign_name: string;
}

interface SmsCampaignstViewState {
    smscampaignlistviewsdata: SmsCampaignListViews[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}


// // ==================view-Smscampaign-api-start=============
export const GetSmsCampaignListView = createAsyncThunk<
    SmsCampaignListViews,
    number,
    { rejectValue: string }
>(
    'smscampaignlistviewsdata/GetSmsCampaignListView',
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/sms-campaign/lists/${id}`);
            return response.data.SMSCampaignList;
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
// // ==================view-Smscampaign-api-end============

const initialState: SmsCampaignstViewState = {
    smscampaignlistviewsdata: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignlistviewSlice = createSlice({
    name: "Smscampaignview",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetSmsCampaignListView.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetSmsCampaignListView.fulfilled, (state, action: PayloadAction<SmsCampaignListViews>) => {
                state.loading = false;
                state.error = null;
                state.smscampaignlistviewsdata = [action.payload];
            })
            .addCase(GetSmsCampaignListView.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default smscampaignlistviewSlice.reducer;